var React = require('react');

function DesktopDownloadIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 0a1 1 0 0 1 1 1v7.586l1.293-1.293a1 1 0 1 1 1.414 1.414L8 12.414 4.293 8.707a1 1 0 0 1 1.414-1.414L7 8.586V1a1 1 0 0 1 1-1zm0 16a8 8 0 0 0 4.413-14.674C11.775.904 11 1.416 11 2.181c0 .385.21.734.521.96a6 6 0 1 1-7.042 0c.311-.226.521-.575.521-.96 0-.765-.775-1.277-1.413-.855A8 8 0 0 0 8 16z","fill":"#020D1C","opacity":".5"}));
}

DesktopDownloadIcon.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = DesktopDownloadIcon;

DesktopDownloadIcon.default = DesktopDownloadIcon;
